var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "tai-xiu-board",
      class: {
        compact: _vm.compact,
        full: _vm.full,
        fancy: _vm.isFancy,
        "betting-closed": !_vm.isBetOpen,
      },
    },
    [
      !_vm.full && !_vm.hideHeader
        ? _c(
            "header",
            { staticClass: "board-header" },
            [
              _c("div", { staticClass: "table-identity" }, [
                _c("strong", [
                  _c("span", { staticClass: "table-id" }, [
                    _vm._v(
                      _vm._s(_vm.table.code) + " #" + _vm._s(_vm.table.round)
                    ),
                  ]),
                ]),
                !_vm.isFancy
                  ? _c("span", [_vm._v(_vm._s(_vm.table.name))])
                  : _vm._e(),
              ]),
              _vm.isFancy
                ? _c("TaiXiuDiceRow", {
                    staticClass: "header-dice",
                    attrs: {
                      table: _vm.table,
                      "is-rolling": _vm.isRolling,
                      "float-result": "",
                    },
                  })
                : _vm._e(),
              _vm.isFancy
                ? _c("div", { staticClass: "time" }, [
                    _vm.compact
                      ? _c(
                          "button",
                          {
                            staticClass: "sheet-close",
                            attrs: {
                              type: "button",
                              "aria-label": _vm.$t("Close"),
                            },
                            on: { click: _vm.onClose },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/images/quick-play-close.svg"),
                                alt: "",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm.table.autoClose
                ? _c(
                    "div",
                    {
                      staticClass: "timer",
                      class: { closing: _vm.table.secondsRemaining <= 5 },
                    },
                    [_vm._v(" 00:" + _vm._s(_vm.paddedSeconds) + "s ")]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      !_vm.isFancy
        ? _c("div", { staticClass: "mock-video" }, [
            _c("div", { staticClass: "video-label" }, [
              _vm._v(_vm._s(_vm.$t("Mock Tài Xỉu feed"))),
            ]),
            _c(
              "div",
              {
                staticClass: "dice-result",
                class: {
                  rolling: _vm.diceAreRolling,
                  continuous: _vm.diceAreRollingContinuously,
                },
              },
              _vm._l(_vm.resultDice, function (die, index) {
                return _c("img", {
                  key: index,
                  attrs: {
                    src: _vm.diceImage(die),
                    alt: `Die ${index + 1}: ${die}`,
                  },
                })
              }),
              0
            ),
            _c("small", [_vm._v(_vm._s(_vm.$t("Prototype data only")))]),
          ])
        : _vm._e(),
      _vm.isFancy
        ? [
            _c(
              "div",
              { staticClass: "full-board-body" },
              [
                _c("div", { staticClass: "tx-info-bar" }, [
                  _vm._v(
                    _vm._s(_vm.$t("ALL PAY")) + " " + _vm._s(_vm.bigSmallOdds)
                  ),
                ]),
                _c("div", { staticClass: "tx-main-row" }, [
                  _c(
                    "button",
                    {
                      staticClass: "tx-main-bet tx-main-bet--tai",
                      class: {
                        selected: _vm.displayBets.tai,
                        "result-matched": _vm.isResultMatch("tai"),
                        blocked: _vm.isSelectionBlocked("tai"),
                      },
                      attrs: {
                        type: "button",
                        disabled:
                          !_vm.isBetOpen || _vm.isSelectionBlocked("tai"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onBet("tai")
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v("TÀI")]),
                      _c("span", { staticClass: "sub" }, [_vm._v("BIG 11-17")]),
                      _vm.displayBets.tai
                        ? _c("BetPlacedChip", {
                            attrs: {
                              amount: _vm.displayBets.tai,
                              chips: _vm.chips,
                              placement: "top-left",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "tx-odd-even" }, [
                    _c(
                      "button",
                      {
                        staticClass: "tx-odd-even__btn tx-odd-even__btn--odd",
                        class: {
                          selected: _vm.displayBets.odd,
                          "result-matched": _vm.isResultMatch("odd"),
                          blocked: _vm.isSelectionBlocked("odd"),
                        },
                        attrs: {
                          type: "button",
                          disabled:
                            !_vm.isBetOpen || _vm.isSelectionBlocked("odd"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onBet("odd")
                          },
                        },
                      },
                      [
                        _c("span", [_vm._v("LẺ")]),
                        _c("small", [_vm._v("ODD")]),
                        _vm.displayBets.odd
                          ? _c("BetPlacedChip", {
                              attrs: {
                                amount: _vm.displayBets.odd,
                                chips: _vm.chips,
                                placement: "top-right",
                                overlap: "",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "tx-odd-even__btn tx-odd-even__btn--even",
                        class: {
                          selected: _vm.displayBets.even,
                          "result-matched": _vm.isResultMatch("even"),
                          blocked: _vm.isSelectionBlocked("even"),
                        },
                        attrs: {
                          type: "button",
                          disabled:
                            !_vm.isBetOpen || _vm.isSelectionBlocked("even"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onBet("even")
                          },
                        },
                      },
                      [
                        _c("span", [_vm._v("CHẴN")]),
                        _c("small", [_vm._v("EVEN")]),
                        _vm.displayBets.even
                          ? _c("BetPlacedChip", {
                              attrs: {
                                amount: _vm.displayBets.even,
                                chips: _vm.chips,
                                placement: "top-right",
                                overlap: "",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "tx-main-bet tx-main-bet--xiu",
                      class: {
                        selected: _vm.displayBets.xiu,
                        "result-matched": _vm.isResultMatch("xiu"),
                        blocked: _vm.isSelectionBlocked("xiu"),
                      },
                      attrs: {
                        type: "button",
                        disabled:
                          !_vm.isBetOpen || _vm.isSelectionBlocked("xiu"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onBet("xiu")
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v("XỈU")]),
                      _c("span", { staticClass: "sub" }, [
                        _vm._v("SMALL 4-10"),
                      ]),
                      _vm.displayBets.xiu
                        ? _c("BetPlacedChip", {
                            attrs: {
                              amount: _vm.displayBets.xiu,
                              chips: _vm.chips,
                              placement: "top-right",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                !_vm.compact
                  ? _c("div", { staticClass: "tx-triple-section" }, [
                      _c(
                        "div",
                        { staticClass: "tx-info-bar tx-info-bar--triple" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("TRIPLE")) +
                              " " +
                              _vm._s(_vm.tripleOdds)
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "tx-triple-row" },
                        _vm._l(_vm.tripleComboSlots, function (slot) {
                          return _c("BetTripleComboBtn", {
                            key: slot.face,
                            attrs: {
                              face: slot.face,
                              odds: _vm.tripleOdds,
                              selected:
                                !!_vm.displayBets[`triple-${slot.face}`],
                              "result-matched": _vm.isResultMatch(
                                `triple-${slot.face}`
                              ),
                              amount: _vm.displayBets[`triple-${slot.face}`],
                              chips: _vm.chips,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onBet(`triple-${slot.face}`)
                              },
                            },
                          })
                        }),
                        1
                      ),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "full-sum-rows" }, [
                  _c(
                    "div",
                    { staticClass: "sum-grid" },
                    _vm._l(_vm.lowSums, function (sum) {
                      return _c(
                        "button",
                        {
                          key: sum,
                          class: {
                            selected: _vm.displayBets[`sum-${sum}`],
                            "result-matched": _vm.isResultMatch(`sum-${sum}`),
                          },
                          attrs: { type: "button", disabled: !_vm.isBetOpen },
                          on: {
                            click: function ($event) {
                              return _vm.onBet(`sum-${sum}`)
                            },
                          },
                        },
                        [
                          _c("strong", [_vm._v(_vm._s(sum))]),
                          _c("small", [_vm._v(_vm._s(_vm.totalOdds(sum)))]),
                          _vm.displayBets[`sum-${sum}`]
                            ? _c("BetPlacedChip", {
                                attrs: {
                                  amount: _vm.displayBets[`sum-${sum}`],
                                  chips: _vm.chips,
                                  placement: "top-right",
                                  overlap: "",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _c(
                    "div",
                    { staticClass: "sum-grid" },
                    _vm._l(_vm.highSums, function (sum) {
                      return _c(
                        "button",
                        {
                          key: sum,
                          class: {
                            selected: _vm.displayBets[`sum-${sum}`],
                            "result-matched": _vm.isResultMatch(`sum-${sum}`),
                          },
                          attrs: { type: "button", disabled: !_vm.isBetOpen },
                          on: {
                            click: function ($event) {
                              return _vm.onBet(`sum-${sum}`)
                            },
                          },
                        },
                        [
                          _c("strong", [_vm._v(_vm._s(sum))]),
                          _c("small", [_vm._v(_vm._s(_vm.totalOdds(sum)))]),
                          _vm.displayBets[`sum-${sum}`]
                            ? _c("BetPlacedChip", {
                                attrs: {
                                  amount: _vm.displayBets[`sum-${sum}`],
                                  chips: _vm.chips,
                                  placement: "top-right",
                                  overlap: "",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]),
                _c("div", { staticClass: "tx-info-bar tx-info-bar--single" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("SINGLE")) + " " + _vm._s(_vm.singleOdds)
                    ),
                  ]),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("DOUBLE")) + " " + _vm._s(_vm.doubleOdds)
                    ),
                  ]),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("TRIPLE")) +
                        " " +
                        _vm._s(_vm.singleTripleOdds)
                    ),
                  ]),
                ]),
                _c("BetDiceMarketSection", {
                  staticClass: "tx-dice-market",
                  attrs: {
                    "draft-bets": _vm.displayBets,
                    chips: _vm.chips,
                    "die-faces": _vm.dieFaces,
                    "show-triple": false,
                    "matched-faces": _vm.showResultHighlights
                      ? _vm.tableResultDice
                      : [],
                    "single-odds": _vm.singleOdds,
                    "double-odds": _vm.doubleOdds,
                    "triple-odds": _vm.singleTripleOdds,
                  },
                  on: { bet: _vm.onBet },
                }),
              ],
              1
            ),
            _vm._t("under-board"),
            _c("BetBoardActions", {
              attrs: {
                chips: _vm.chips,
                "active-chip": _vm.activeChip,
                "chip-colors": _vm.chipColors,
                "can-undo": _vm.canUndo,
                "has-bets": _vm.hasBets,
                "total-bet": _vm.totalBet,
                "currency-symbol": _vm.currencySymbol,
                "is-submitting": _vm.isSubmitting,
                "is-rolling": _vm.isRolling,
                "betting-disabled": !_vm.isBetOpen,
                "pin-bottom": false,
                "arena-id": _vm.tableArenaId,
                fancy: "",
              },
              on: {
                undo: function ($event) {
                  return _vm.$emit("undo")
                },
                clear: function ($event) {
                  return _vm.$emit("clear")
                },
                "select-chip": function ($event) {
                  return _vm.$emit("select-chip", $event)
                },
                submit: function ($event) {
                  return _vm.$emit("submit")
                },
              },
            }),
            _vm.full && !_vm.hideCharts
              ? _c("BetHistoryCharts", {
                  attrs: {
                    "recent-results": _vm.table.recentResults,
                    "recent-dice": _vm.table.recentDice,
                    "recent-rounds": _vm.table.recentRounds,
                    code: _vm.table.code,
                  },
                })
              : _vm._e(),
          ]
        : [
            _c("div", { staticClass: "primary-bets" }, [
              _c(
                "button",
                {
                  staticClass: "primary-bet-tai",
                  class: {
                    selected: _vm.displayBets.tai,
                    "result-matched": _vm.isResultMatch("tai"),
                    blocked: _vm.isSelectionBlocked("tai"),
                  },
                  attrs: {
                    type: "button",
                    disabled: !_vm.isBetOpen || _vm.isSelectionBlocked("tai"),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onBet("tai")
                    },
                  },
                },
                [
                  _c("span", [_vm._v("TÀI")]),
                  _c("span", { staticClass: "primary-bet-tai sub" }, [
                    _vm._v("BIG 11-17"),
                  ]),
                  _c("small", { staticClass: "odds" }, [
                    _vm._v(_vm._s(_vm.bigSmallOdds)),
                  ]),
                  _vm.displayBets.tai
                    ? _c("BetPlacedChip", {
                        attrs: {
                          amount: _vm.displayBets.tai,
                          chips: _vm.chips,
                          placement: "top-left",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c("div", { staticClass: "secondary-bets" }, [
                _c(
                  "button",
                  {
                    class: {
                      selected: _vm.displayBets.odd,
                      "result-matched": _vm.isResultMatch("odd"),
                      blocked: _vm.isSelectionBlocked("odd"),
                    },
                    attrs: {
                      type: "button",
                      disabled: !_vm.isBetOpen || _vm.isSelectionBlocked("odd"),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onBet("odd")
                      },
                    },
                  },
                  [
                    _c("span", [_vm._v("LẺ - ODD")]),
                    _c("small", [_vm._v(_vm._s(_vm.oddEvenOdds))]),
                    _vm.displayBets.odd
                      ? _c("BetPlacedChip", {
                          attrs: {
                            amount: _vm.displayBets.odd,
                            chips: _vm.chips,
                            placement: "top-right",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    class: {
                      selected: _vm.displayBets.even,
                      "result-matched": _vm.isResultMatch("even"),
                      blocked: _vm.isSelectionBlocked("even"),
                    },
                    attrs: {
                      type: "button",
                      disabled:
                        !_vm.isBetOpen || _vm.isSelectionBlocked("even"),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onBet("even")
                      },
                    },
                  },
                  [
                    _c("span", [_vm._v("CHẴN - EVEN")]),
                    _c("small", [_vm._v(_vm._s(_vm.oddEvenOdds))]),
                    _vm.displayBets.even
                      ? _c("BetPlacedChip", {
                          attrs: {
                            amount: _vm.displayBets.even,
                            chips: _vm.chips,
                            placement: "top-right",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c(
                "button",
                {
                  staticClass: "primary-bet-xiu",
                  class: {
                    selected: _vm.displayBets.xiu,
                    "result-matched": _vm.isResultMatch("xiu"),
                    blocked: _vm.isSelectionBlocked("xiu"),
                  },
                  attrs: {
                    type: "button",
                    disabled: !_vm.isBetOpen || _vm.isSelectionBlocked("xiu"),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onBet("xiu")
                    },
                  },
                },
                [
                  _c("span", [_vm._v("XỈU")]),
                  _c("span", { staticClass: "primary-bet-xiu sub" }, [
                    _vm._v("SMALL 4-10"),
                  ]),
                  _c("small", { staticClass: "odds" }, [
                    _vm._v(_vm._s(_vm.bigSmallOdds)),
                  ]),
                  _vm.displayBets.xiu
                    ? _c("BetPlacedChip", {
                        attrs: {
                          amount: _vm.displayBets.xiu,
                          chips: _vm.chips,
                          placement: "top-right",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "sum-grid" },
              _vm._l(_vm.sums, function (sum) {
                return _c(
                  "button",
                  {
                    key: sum,
                    class: {
                      selected: _vm.displayBets[`sum-${sum}`],
                      "result-matched": _vm.isResultMatch(`sum-${sum}`),
                    },
                    attrs: { type: "button", disabled: !_vm.isBetOpen },
                    on: {
                      click: function ($event) {
                        return _vm.onBet(`sum-${sum}`)
                      },
                    },
                  },
                  [
                    _c("strong", [_vm._v(_vm._s(sum))]),
                    _c("small", [_vm._v(_vm._s(_vm.totalOdds(sum)))]),
                    _vm.displayBets[`sum-${sum}`]
                      ? _c("BetPlacedChip", {
                          attrs: {
                            amount: _vm.displayBets[`sum-${sum}`],
                            chips: _vm.chips,
                            placement: "top-right",
                            overlap: "",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
              0
            ),
            _c("BetDiceMarketSection", {
              attrs: {
                "draft-bets": _vm.displayBets,
                chips: _vm.chips,
                "die-faces": _vm.dieFaces,
                "show-triple": _vm.full,
                "matched-faces": _vm.showResultHighlights
                  ? _vm.tableResultDice
                  : [],
                "single-odds": _vm.singleOdds,
                "double-odds": _vm.doubleOdds,
                "triple-odds": _vm.singleTripleOdds,
              },
              on: { bet: _vm.onBet },
            }),
            _vm.isFancy
              ? _c("BetBoardActions", {
                  attrs: {
                    chips: _vm.chips,
                    "active-chip": _vm.activeChip,
                    "chip-colors": _vm.chipColors,
                    "can-undo": _vm.canUndo,
                    "has-bets": _vm.hasBets,
                    "total-bet": _vm.totalBet,
                    "currency-symbol": _vm.currencySymbol,
                    "is-submitting": _vm.isSubmitting,
                    "is-rolling": _vm.isRolling,
                    "betting-disabled": !_vm.isBetOpen,
                    "arena-id": _vm.tableArenaId,
                    fancy: "",
                  },
                  on: {
                    undo: function ($event) {
                      return _vm.$emit("undo")
                    },
                    clear: function ($event) {
                      return _vm.$emit("clear")
                    },
                    "select-chip": function ($event) {
                      return _vm.$emit("select-chip", $event)
                    },
                    submit: function ($event) {
                      return _vm.$emit("submit")
                    },
                  },
                })
              : _c(
                  "div",
                  { staticClass: "board-actions" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "undo-action",
                        attrs: { type: "button", disabled: !_vm.canUndo },
                        on: {
                          mousedown: function ($event) {
                            return _vm.onUndoPressStart("mousedown")
                          },
                          mouseup: function ($event) {
                            return _vm.onUndoPressEnd("mouseup")
                          },
                          mouseleave: _vm.onUndoPressCancel,
                          touchstart: function ($event) {
                            $event.preventDefault()
                            return _vm.onUndoPressStart("touchstart")
                          },
                          touchend: function ($event) {
                            return _vm.onUndoPressEnd("touchend")
                          },
                          touchcancel: _vm.onUndoPressCancel,
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/svg/btns/undo.svg"),
                            alt: "",
                          },
                        }),
                        _c("small", [_vm._v(_vm._s(_vm.$t("Undo")))]),
                      ]
                    ),
                    _c("BetChipSelector", {
                      staticClass: "chips",
                      attrs: {
                        chips: _vm.chips,
                        "active-chip": _vm.activeChip,
                        "chip-colors": _vm.chipColors,
                        fancy: false,
                        "arena-id": _vm.tableArenaId,
                      },
                      on: {
                        "select-chip": function ($event) {
                          return _vm.$emit("select-chip", $event)
                        },
                      },
                    }),
                    _c(
                      "button",
                      {
                        staticClass: "text-action",
                        attrs: { type: "button", disabled: !_vm.hasBets },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("clear")
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Clear")) + " ")]
                    ),
                    _c("div", { staticClass: "stake-total" }, [
                      _c("span", [_vm._v("STAKE")]),
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.currencySymbol) +
                            " " +
                            _vm._s(_vm.formatAmount(_vm.totalBet))
                        ),
                      ]),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "bet-action",
                        attrs: {
                          type: "button",
                          disabled:
                            _vm.isSubmitting ||
                            _vm.isRolling ||
                            !_vm.isBetOpen ||
                            !_vm.hasBets,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("submit")
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.isRolling ? _vm.$t("Rolling") : _vm.$t("Bet")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
          ],
      _vm.feedback && !_vm.isFancy
        ? _c("p", { staticClass: "feedback", attrs: { role: "status" } }, [
            _vm._v(_vm._s(_vm.$t(_vm.feedback))),
          ])
        : _vm._e(),
      !_vm.isFancy
        ? _c(
            "div",
            { staticClass: "recent-results" },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t("Recent results")))]),
              _vm._l(_vm.table.recentResults, function (result, index) {
                return _c(
                  "i",
                  {
                    key: `${result}-${index}`,
                    class: result > 10 ? "tai" : "xiu",
                  },
                  [_vm._v(" " + _vm._s(result) + " ")]
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }